import * as React from "react";
import { reduxForm, InjectedFormProps, formValueSelector } from "redux-form";
import { AppState } from "../../../../store/app_state";
import { Action, Dispatch } from "redux";
import { connect } from "react-redux";

import { Contract } from "../../../../../domain/model/contract";
import { Project } from "../../../../../domain/model/project";
import { Customer } from "../../../../../domain/model/customer";
// import { frontEndConfig } from "../../../../../config/config";

import ContractCustomerContent from "../share/contract_customer_content";
import Table from "../../../../common/atom/table/table";
import Tbody from "../../../../common/atom/table/tbody";
import Tr from "../../../../common/atom/table/tr";
import ThWithText from "../../../../common/atom/table/th_with_text";
import TdWithText from "../../../../common/atom/table/td_with_text";
// import ParagraphSup from "../../../../common/atom/text/paragraph_sup";
// import BtnCorporateMiddle from "../../../../common/atom/btn/btn_corporate_middle";
// import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
// import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import styled from "styled-components";
import {
  ConstColor,
  ConstFontWeight,
} from "../../../../../config/styles_const/styles_const";
// import {
//   createFileUsecase,
//   IFileUseCase,
// } from "../../../../../domain/usecase/file_usecase";

// const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

// const fileUseCase: IFileUseCase = createFileUsecase();
// const convertGStoHTTPS = (gsURL: string): Promise<string> => {
//   return fileUseCase.convertGStoHTTPS(gsURL);
// };

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

interface IStateProps {
  initialValues:
    | {
        project: Project | null;
        customer: Customer | null;
        contract: Contract | null;
        fileURLFileObject?: File;
      }
    | undefined;
  formValues: any;
}

interface IProps extends IStateProps {
  onApprove: (id: string) => void;
}

interface IState {
  imageError: string | null;
}

export class ClientContractMainEditForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {
      imageError: null,
    };
  }

  public render(): JSX.Element {
    // const { handleSubmit, pristine, submitting } = this.props;

    const { project, customer, contract } = this.props.initialValues;

    if (!contract || !project || !customer) {
      return <div />;
    }

    let res: JSX.Element;

    const createdAtString: string = contract.getCreatedAtString();
    const projectName: string = project.name;
    const customerName: string = customer.name;
    const fileUrl: string = contract.gsFileURL;

    // 編集
    res = (
      <React.Fragment>
        <ContractCustomerContent customer={customer} />

        <TableWrapper>
          <Table>
            <Tbody>
              <Tr>
                <ThWithText>成約ステータス</ThWithText>
                <TdWithText colSpan={3}>{contract.statusStr()}</TdWithText>
              </Tr>
              <Tr>
                <ThWithText>成約報告日</ThWithText>
                <TdWithText colSpan={3}>{createdAtString}</TdWithText>
              </Tr>
              <Tr>
                <ThWithText>案件名</ThWithText>
                <TdWithText colSpan={3}>{projectName}</TdWithText>
              </Tr>
              <Tr>
                <ThWithText>顧客名</ThWithText>
                <TdWithText colSpan={3}>{customerName}</TdWithText>
              </Tr>
              <Tr>
                <ThWithText>契約書</ThWithText>
                <TdWithText colSpan={3}>
                  {" "}
                  {fileUrl && (
                    <FileLinkText
                      href={fileUrl}
                      // onClick={this.handleClickFile}
                      target="_blank"
                      rel="noopener"
                    >
                      File
                    </FileLinkText>
                  )}
                </TdWithText>
              </Tr>
            </Tbody>
          </Table>
        </TableWrapper>

        <TableWrapper>
          <Table>
            <Tbody>
              <Tr>
                <ThWithText>契約のタイトル</ThWithText>
                <TdWithText colSpan={3}>{contract.title}</TdWithText>
              </Tr>
              <Tr>
                <ThWithText>契約時期</ThWithText>
                <TdWithText colSpan={3}>
                  {contract.startFromYM}〜{contract.endToYM}
                </TdWithText>
              </Tr>
              {contract.hasMeetingInfo() && (
                <Tr>
                  <ThWithText>打ち合わせ</ThWithText>
                  <TdWithText colSpan={3}>
                    {contract.meetingNum}/{contract.meetingIntervalStr()}
                    の頻度で、1回あたり約{contract.meetingMinutes}
                    分の打ち合わせを想定
                  </TdWithText>
                </Tr>
              )}
              {contract.hasWorkingInfo() && (
                <Tr>
                  <ThWithText>実稼働</ThWithText>
                  <TdWithText colSpan={3}>
                    約{contract.workingHour}時間/{contract.workingIntervalStr()}
                    の実稼働を想定
                  </TdWithText>
                </Tr>
              )}
              <Tr>
                <ThWithText>契約の報酬</ThWithText>
                <TdWithText colSpan={3}>{contract.feePerMonth}円/月</TdWithText>
              </Tr>
              <Tr>
                <ThWithText>契約の種類</ThWithText>
                <TdWithText colSpan={3}>
                  {contract.contractTypeStr()}
                </TdWithText>
              </Tr>
              <Tr>
                <ThWithText>業務内容</ThWithText>
                <TdWithText colSpan={3}>{contract.description}</TdWithText>
              </Tr>
            </Tbody>
          </Table>
        </TableWrapper>

        {/* <form name="ClientContractMainEditForm" onSubmit={handleSubmit}>
          <InputWrapper>
            {this.props.formValues && (
              <ParagraphSup>UploadFile有り</ParagraphSup>
            )}

            <input
              accept="application/pdf,
                                    application/vnd.ms-powerpoint,
                                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                    application/msword,
                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                    application/vnd.ms-excel,
                                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              id="contained-button-file"
              multiple={false}
              type="file"
              onChange={this.handleOnChange}
            />
            {this.state.imageError && <mark>{this.state.imageError}</mark>}
            <label htmlFor="contained-button-file">
              <BtnCorporateMiddle
                name="contained-button-file"
                as={"span"}
                widthSize={"200px"}
              >
                契約書をアップロード
              </BtnCorporateMiddle>
            </label>
          </InputWrapper>

          <InputTextWrapper>
            <InputText>※契約書のアップロードは任意です</InputText>
          </InputTextWrapper>

          <SubmitButtonWrapper>
            <BtnCorporateLarge
              name="ClientContractMainEditForm-submit"
              type="submit"
              widthSize="200px"
              disabled={pristine || submitting}
            >
              送信する
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </form> */}
      </React.Fragment>
    );

    return res;
  }

  // public handleClickFile = (event: React.MouseEvent<HTMLElement>): boolean => {
  //   const a = event.currentTarget as HTMLAnchorElement;

  //   if (/^gs:/.test(a.href)) {
  //     event.preventDefault();
  //     convertGStoHTTPS(a.href).then((url: string) => {
  //       a.href = url;
  //       a.click();
  //     });
  //     return false;
  //   }

  //   return false;
  // };

  // private handleOnChange = (e: any) => {
  //   const target: HTMLInputElement = e.target as HTMLInputElement;
  //   const file: File | null = target.files ? target.files.item(0) : null;

  //   try {
  //     this.setState({ imageError: null });
  //     if (file) {
  //       if (file.size > uploadFileMaxSize) {
  //         throw new Error("ファイルサイズオーバ");
  //       } else {
  //         this.props.change("fileURLFileObject", file);
  //       }
  //     }
  //   } catch (error) {
  //     this.setState({ imageError: error.message });
  //   }
  // };
}

const selector = formValueSelector("ClientContractMainEditForm");

const mapStateToProps = (state: AppState) => {
  return {
    formValues: selector(state, "fileURLFileObject"),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  form: "ClientContractMainEditForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(ClientContractMainEditForm));

const TableWrapper = styled.div`
  margin-bottom: 40px;
`;

// const InputWrapper = styled.div`
//   text-align: center;
//   & > input {
//     display: none;
//   }
//   margin-bottom: 10px;
// `;

// const InputTextWrapper = styled.div`
//   margin-bottom: 50px;
//   text-align: center;
// `;

// const InputText = styled(ParagraphSup)`
//   color: ${ConstColor.Gray};
// `;

const FileLinkText = styled.a`
    font-weight: ${ConstFontWeight.BOLD}
    color: ${ConstColor.Corporate};
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/contract/edit/client_contract_main_edit_form.tsx